import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';
import type { SalesHealthOverview } from '../../../../src/sales-health/overview.js';
import {
  getDashboardSalesHealth,
  getDashboardSalesHealthQueryKey,
} from '../api/dashboard.client.js';

/**
 * Read-only Sales Health projection for the My day widget. Same retry policy
 * as the briefing hook: no automatic retries, gated on an active workspace.
 */
export function useSalesHealthOverview(): UseQueryResult<SalesHealthOverview> {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId;

  return useQuery({
    queryKey: workspaceId
      ? getDashboardSalesHealthQueryKey(workspaceId)
      : ['dashboard', 'no-workspace', 'sales-health'],
    queryFn: () => getDashboardSalesHealth(),
    retry: false,
    enabled: Boolean(workspaceId),
  });
}
